export default{
  "Video Compressor": "비디오 압축기",
  "HitPaw Online Video Compressor": "HitPaw 온라인 비디오 압축기",
  "Best video compressor tool to reduce video file size online without losing quality.": "품질 저하 없이 온라인으로 비디오 파일 크기를 줄일 수 있는 최상의 비디오 압축기 도구입니다.",
  "Quality": "품질",
  "Small Size": "작은 크기({{num}}%)",
  "High Quality": "고품질({{num}}%)",
  "Frame Rate": "프레임 속도",
  "Resolution": "해상도",
  "Keep Resolution": "해상도 유지",
  "Format": "형식",
  "Compress": "압축하기",
  "Compressing": "중입니다.",
  "Compress New": "새로 압축하기",
  "xx% reduction in size!": "{{num}}% 크기 축소했습니다!",
  "Compressed successfully, your file is now xxMB.": "압축이 완료되었습니다. 이제 파일이 <p> {{originalSize}}MB</p> <p>{{compressSize}}MB</p>입니다.",
  "Compression Failed": "압축에 실패했습니다.",
};